window.theme = window.theme || {};

/**
 * Dawn-style pub/sub + cookie helpers, formerly bundled inside vendor.js (deleted in #23).
 * Top-level declarations here are globals for cart.js, quick-order-list.js,
 * price-per-item.js, recipient-form.js and the inline section scripts using
 * setCookie/getCookie. theme.js loads before all of them in theme.liquid.
 */
var PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};
var subscribers = {};
function subscribe(eventName, callback){
  if (subscribers[eventName] === undefined){
    subscribers[eventName] = [];
  }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe(){
    subscribers[eventName] = subscribers[eventName].filter(function(cb){ return cb !== callback; });
  };
}
function publish(eventName, data){
  if (subscribers[eventName]){
    subscribers[eventName].forEach(function(callback){ callback(data); });
  }
}
function setCookie(name, value, days){
  var date = new Date();
  date.setTime(date.getTime() + 864e5 * days);
  document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=None; secure';
}
function getCookie(name){
  var pairs = document.cookie.split(';');
  for (var i = 0; i < pairs.length; i++){
    var eq = pairs[i].indexOf('=');
    var key = pairs[i].substr(0, eq).replace(/^\s+|\s+$/g, '');
    if (key === name) return unescape(pairs[i].substr(eq + 1));
  }
}

/** Shared vanilla-JS helpers used across the ported (jQuery-free) pieces of this file. */
theme.utils = {
  onReady: function(fn){
    if (document.readyState !== 'loading'){
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  },

  // Mirrors jQuery's .data(name) auto-coercion ("true"/"false"/numbers/JSON
  // strings are parsed; anything else falls back to the raw attribute string).
  parseData: function(el, name){
    if (!el) return undefined;
    var raw = el.getAttribute('data-' + name);
    if (raw === null) return undefined;
    try {
      return JSON.parse(raw);
    } catch (e){
      return raw;
    }
  },

  // jQuery's $(selector) resolved a bare "#id" through getElementById, which accepts
  // IDs that start with a digit — Shopify block-id UUIDs (e.g. "1ffe1f05-…") do.
  // querySelector(All) instead parses "#1ffe…" as a CSS selector and throws
  // SyntaxError ("not a valid selector"). These lookups come from data-link / href
  // attributes holding "#<block-id>…", so route a bare "#id" via getElementById to
  // restore the old jQuery behavior; anything else falls through to the DOM query.
  idOrQuery: function(selector){
    var m = /^#([\w-]+)$/.exec(selector || '');
    return m ? document.getElementById(m[1]) : document.querySelector(selector);
  },
  idOrQueryAll: function(selector){
    var m = /^#([\w-]+)$/.exec(selector || '');
    if (m){ var el = document.getElementById(m[1]); return el ? [el] : []; }
    return document.querySelectorAll(selector);
  },

  slideUp: function(el, duration){
    if (!el) return;
    if (getComputedStyle(el).display === 'none') return; // idempotent, like jQuery
    duration = duration || 400;
    if (!el.animate){
      el.style.display = 'none';
      return;
    }
    el.style.overflow = 'hidden';
    var startHeight = el.offsetHeight;
    var anim = el.animate([
      { height: startHeight + 'px' },
      { height: '0px' }
    ], { duration: duration, easing: 'ease' });
    anim.onfinish = function(){
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
    };
  },

  slideDown: function(el, duration){
    if (!el) return;
    if (getComputedStyle(el).display !== 'none') return; // idempotent, like jQuery
    duration = duration || 400;
    el.style.removeProperty('display');
    var computedDisplay = getComputedStyle(el).display;
    if (computedDisplay === 'none') computedDisplay = 'block';
    el.style.display = computedDisplay;
    if (!el.animate){
      return;
    }
    var endHeight = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    var anim = el.animate([
      { height: '0px' },
      { height: endHeight + 'px' }
    ], { duration: duration, easing: 'ease' });
    anim.onfinish = function(){
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
    };
  },

  slideToggle: function(el, show){
    if (!el) return;
    if (typeof show === 'undefined'){
      show = getComputedStyle(el).display === 'none';
    }
    if (show){
      theme.utils.slideDown(el);
    } else {
      theme.utils.slideUp(el);
    }
  },

  fadeIn: function(el, duration){
    if (!el) return;
    if (getComputedStyle(el).display !== 'none') return; // idempotent, like jQuery
    duration = duration || 200;
    el.style.removeProperty('display');
    var computedDisplay = getComputedStyle(el).display;
    if (computedDisplay === 'none') computedDisplay = 'block';
    el.style.display = computedDisplay;
    if (!el.animate){
      el.style.removeProperty('opacity');
      return;
    }
    el.style.opacity = 0;
    var anim = el.animate([
      { opacity: 0 },
      { opacity: 1 }
    ], { duration: duration, easing: 'linear' });
    anim.onfinish = function(){
      el.style.removeProperty('opacity');
    };
  },

  fadeOut: function(el, duration){
    if (!el) return;
    if (getComputedStyle(el).display === 'none') return; // idempotent, like jQuery
    duration = duration || 200;
    if (!el.animate){
      el.style.display = 'none';
      return;
    }
    var anim = el.animate([
      { opacity: 1 },
      { opacity: 0 }
    ], { duration: duration, easing: 'linear' });
    anim.onfinish = function(){
      el.style.display = 'none';
      el.style.removeProperty('opacity');
    };
  },

  fadeToggle: function(el, show){
    if (!el) return;
    if (typeof show === 'undefined'){
      show = getComputedStyle(el).display === 'none';
    }
    if (show){
      theme.utils.fadeIn(el);
    } else {
      theme.utils.fadeOut(el);
    }
  }
};

theme.Sections = function Sections(){
  this.constructors = {};
  this.instances = [];
  document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
  document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
  document.addEventListener('shopify:section:select', this._onSelect.bind(this));
  document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
  document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
  document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
Object.assign(theme.Sections.prototype, {
  _createInstance: function(container, constructor){
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined'){
      return;
    }

    var instance;
    try {
      instance = new constructor(container);
    } catch (err){
      console.error('[theme.Sections]', type, err);
      return;
    }
    Object.assign(instance, { id: id, type: type, container: container });
    this.instances.push(instance);
  },
  _onSectionLoad: function(evt){
    var container = evt.target.querySelector('[data-section-id]');
    if (container){
      this._createInstance(container);
    }
  },
  _onSectionUnload: function(evt){
    this.instances = this.instances.filter(function(instance){
      var isEventInstance = (instance.id === evt.detail.sectionId);
      if (isEventInstance){
        if (typeof instance.onUnload === 'function'){ instance.onUnload(evt); }
      }
      return !isEventInstance;
    });
  },
  _onSelect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onSelect === 'function'){
      instance.onSelect(evt);
    }
  },
  _onDeselect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });

    if (typeof instance !== 'undefined' && typeof instance.onDeselect === 'function'){
      instance.onDeselect(evt);
    }
  },
  _onBlockSelect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onBlockSelect === 'function'){
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function(evt){
    var instance = this.instances.find(function(instance){
      return instance.id === evt.detail.sectionId;
    });
    if (typeof instance !== 'undefined' && typeof instance.onBlockDeselect === 'function'){
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor){
    this.constructors[type] = constructor;
    var containers = document.querySelectorAll('[data-section-type="' + type + '"]');
    containers.forEach(function(container){
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/** iFrames ** Wrap videos in div to force responsive layout. */
slate.rte={
  wrapTable: function(){
    document.querySelectorAll('.rte table').forEach(function(table){
      var wrap = document.createElement('div');
      wrap.className = 'tb-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  },

  iframeReset: function(){
    var videoIframes = document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');

    videoIframes.forEach(function(iframe){
      var wrap = document.createElement('div');
      wrap.className = 'vd-wrap';
      iframe.parentNode.insertBefore(wrap, iframe);
      wrap.appendChild(iframe);
    });

    var resetIframes = document.querySelectorAll('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe');
    resetIframes.forEach(function(iframe){
      iframe.src = iframe.src;
    });
  }
};
window.slate = window.slate || {};


// Accepts either a jQuery-like object ([0]/.length) or a plain Element,
// normalizing to a single Element (or null). Needed because assets/password.js
// still calls slate.a11y.trapFocus/removeTrapFocus with jQuery objects.
function _slateToElement(x){
  if (!x) return null;
  if (x instanceof Element) return x;
  if (typeof x.length === 'number'){
    return (x.length && x[0] instanceof Element) ? x[0] : null;
  }
  return null;
}

slate.a11y = {
  /*** For use when focus shifts to a container rather than a link */
  pageLinkFocus: function(element){
    var el = _slateToElement(element);
    if (!el) return;
    var focusClass = 'js-focus-hidden';

    function callback(){
      el.classList.remove(focusClass);
      el.removeAttribute('tabindex');
      el.removeEventListener('blur', callback);
    }

    el.setAttribute('tabindex', '-1');
    el.focus();
    el.classList.add(focusClass);
    el.addEventListener('blur', callback, { once: true });
  },

  /*** If there's a hash in the url, focus the appropriate element */
  focusHash: function(){
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))){
      this.pageLinkFocus(document.getElementById(hash.slice(1)));
    }
  },

  /*** When an in-page (url w/hash) link is clicked, focus the appropriate element */
  bindInPageLinks: function(){
    var self = this;
    document.querySelectorAll('a[href*="#"]').forEach(function(link){
      link.addEventListener('click', function(evt){
        self.pageLinkFocus(document.querySelector(evt.currentTarget.hash));
      });
    });
  },

  trapFocus: function(options){
    var container = _slateToElement(options.$container);
    var elementToFocus = _slateToElement(options.$elementToFocus) || container;

    if (!container) return;

    container.setAttribute('tabindex', '-1');
    if (elementToFocus){ elementToFocus.focus(); }

    if (slate.a11y._trapHandler){
      document.removeEventListener('focusin', slate.a11y._trapHandler);
    }

    slate.a11y._trapHandler = function(evt){
      if (container !== evt.target && !container.contains(evt.target)){
        container.focus();
      }
    };

    document.addEventListener('focusin', slate.a11y._trapHandler);
  },

  removeTrapFocus: function(options){
    options = options || {};
    var container = _slateToElement(options.$container);

    if (container){
      container.removeAttribute('tabindex');
    }

    if (slate.a11y._trapHandler){
      document.removeEventListener('focusin', slate.a11y._trapHandler);
      slate.a11y._trapHandler = null;
    }
  }
};

/** Currency Helpers * - Accounting.js - http://openexchangerates.github.io/accounting.js/ **/
theme.Currency = (function(){
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format){
    if (typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null){
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  }
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.HeaderSection = (function(){
  // Module-level once-guard for the document-level (body persists across header
  // re-render) outside-click closer — per rule 1's house pattern, so it binds a
  // single time instead of re-stacking on every Theme Editor header re-init (the
  // jQuery original bound a body-level click inside the constructor, a leak).
  var documentHandlersBound = false;

  function siblings(el){
    if (!el || !el.parentNode) return [];
    return Array.prototype.filter.call(el.parentNode.children, function(child){
      return child !== el;
    });
  }

  // jQuery `.hover(fn)` with a SINGLE handler binds fn to BOTH mouseenter AND
  // mouseleave (rule 2) — replicated by adding this same handler to both events.
  function hasSubHover(){
    var el = this;
    var submenu = el.getAttribute('data-link');
    el.classList.add('active');
    siblings(el).forEach(function(s){ s.classList.remove('active'); });
    if (submenu){
      theme.utils.idOrQueryAll(submenu).forEach(function(sm){
        sm.classList.add('active');
        siblings(sm).forEach(function(s){ s.classList.remove('active'); });
      });
    }
  }

  function HeaderSection(container){
    this.container = container;

    theme.Search.init();

    var hd = {
      body: 'body',
      mnTgl: '.navToggle,.mbtMenu',
      mbNav: '.mob_nav_wr'
    };

    // Active-link marking — a one-time DOM mutation (not a listener); runs per
    // init, matching the jQuery `.each(...)`.
    document.querySelectorAll('#main_nav .lvl1 > a').forEach(function(a){
      if (a.getAttribute('href') === window.location.pathname){ a.classList.add('active'); }
    });

    // Element-bound per init: the listeners below target elements INSIDE the
    // header, which the Theme Editor destroys + recreates on section re-render —
    // binding per init attaches to the fresh elements exactly as the jQuery
    // `.on('click')` original did (old elements + their listeners go with the old
    // DOM, so nothing stacks).
    document.querySelectorAll(hd.mnTgl).forEach(function(el){
      el.addEventListener('click', function(){
        document.querySelectorAll(hd.mbNav).forEach(function(nav){ nav.classList.toggle('active'); });
        document.documentElement.classList.toggle('showOverly');
        document.documentElement.classList.toggle('stopScroll');
      });
    });

    // Element-bound per init (rule 2): mouseenter/mouseleave are the exact events
    // jQuery `.hover` uses; delegating would require mouseover/mouseout (different
    // bubbling semantics on descendant transitions), so element-bound is the
    // cleanest exact parity for these header-internal, re-rendered elements.
    document.querySelectorAll('#main_nav .hasSub, .cmgmenu .hasSub').forEach(function(el){
      el.addEventListener('mouseenter', hasSubHover);
      el.addEventListener('mouseleave', hasSubHover);
    });

    document.querySelectorAll('.mnvTtl').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        var menu = this.getAttribute('href');
        document.querySelectorAll('.mnvTtl').forEach(function(t){ t.classList.remove('active'); });
        this.classList.add('active');
        document.querySelectorAll('.mobNav').forEach(function(nav){ theme.utils.fadeOut(nav); });
        if (menu){
          theme.utils.idOrQueryAll(menu).forEach(function(m){ theme.utils.fadeIn(m); });
        }
      });
    });

    document.querySelectorAll('.mobNav .hasSub').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        if (document.querySelector('.mobNav.st2')){
          this.classList.toggle('active');
          theme.utils.slideToggle(this.nextElementSibling);
        } else if (this.nextElementSibling){
          this.nextElementSibling.classList.add('active');
        }
      });
    });

    document.querySelectorAll('.mobNav .backto').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        if (this.parentElement){ this.parentElement.classList.remove('active'); }
      });
    });

    document.querySelectorAll('.sdCate .at-icon').forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        this.classList.toggle('minus');
        var sib = this.parentElement ? this.parentElement.nextElementSibling : null;
        theme.utils.slideToggle(sib);
      });
    });

    // Outside-click closer — document-delegated, bound once (see guard above).
    if (!documentHandlersBound){
      documentHandlersBound = true;
      document.addEventListener('click', function(e){
        // `.parents().is(x)` (and, for mnTgl, the additional self `.is(x)`) → per
        // rule 10 becomes `!e.target.closest(x)`; the self-only `.is('.searchIcn')`
        // → `!e.target.matches('.searchIcn')`. Exact close conditions preserved.
        if (!e.target.closest(hd.mbNav) && !e.target.closest(hd.mnTgl)){
          document.querySelectorAll(hd.mbNav).forEach(function(nav){ nav.classList.remove('active'); });
        }
        if (!e.target.closest('.main-search') && !e.target.closest('.searchinline') &&
            !e.target.matches('.searchIcn') && !e.target.closest('.leftcol')){
          document.querySelectorAll('.main-search .s_res, .searchinline .s_res, .hdSearch  .s_res').forEach(function(el){
            theme.utils.fadeOut(el);
          });
        }
        if (!e.target.closest('.sb_filter')){
          document.querySelectorAll('.flTop .filterBx').forEach(function(el){ el.removeAttribute('open'); });
        }
      });
    }
  }
  return HeaderSection;
})();

theme.Search = (function(){
  var selectors={
    search: '.search',
    searchSubmit: '.s_submit',
    searchInput: '.s_input'
  };

  var classes={focus: 'search--focus'};

  // Document-delegated so search forms that get re-rendered (header /
  // section reloads) keep working without rebinding.
  function onSearchInputEvent(e){
    var target = e.target;
    if (!target.matches || !target.matches('input[name="q"]')) return;
    var form = target.closest('form.search');
    if (!form) return;

    var term = target.value;
    var resultsWr = form.querySelector('.s_res');
    var searchList = form.querySelector('#serchList');
    var searchPre = form.querySelector('#searchPre');
    theme.utils.fadeIn(resultsWr);
    if (term.length > 2){
      fetch(`${routes.predictive_search_url}?q=${term}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            if (searchList) searchList.style.display = 'none';
            theme.utils.fadeIn(searchPre);
            throw error;
          }
          return response.text();
        }).then((text) => {
          var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          if (searchList) searchList.innerHTML = text;
          theme.utils.fadeIn(searchList);
          if (searchPre) searchPre.style.display = 'none';
        }).catch((error) => {
          if (searchList) searchList.style.display = 'none';
          throw error;
        });
	} else {
      if (searchList){ searchList.innerHTML = ''; searchList.style.display = 'none'; }
      theme.utils.fadeIn(searchPre);
    }
  }

  var delegatesBound = false;

  function init(){
    // init() re-runs on every HeaderSection re-init (Theme Editor section
    // reload); the listeners below are document-delegated, so bind them once.
    if (delegatesBound) return;
    delegatesBound = true;
    searchSubmit();
    document.addEventListener('focusin', onSearchInputEvent);
    document.addEventListener('keyup', onSearchInputEvent);
    document.addEventListener('change', onSearchInputEvent);

    document.addEventListener('click', function(e){
      if (!e.target.closest('.modalOverly, .closeSearch')) return;
      document.documentElement.classList.remove('showOverly', 'stopScroll', 'searchact');
      document.querySelectorAll('.sb_filter').forEach(function(el){ el.classList.remove('active'); });
    });

    document.addEventListener('click', function(e){
      if (!e.target.closest('.searchIcn')) return;
      e.preventDefault();
      document.documentElement.classList.add('showOverly', 'stopScroll', 'searchact');
      setTimeout(function(){
        var input = document.querySelector('input[name=q]');
        if (input) input.focus();
      }, 600);
    });
  }

  function searchSubmit(){
    document.addEventListener('click', function(evt){
      var el = evt.target.closest(selectors.searchSubmit);
      if (!el) return;
      var searchEl = el.closest(selectors.search);
      var input = searchEl ? searchEl.querySelector(selectors.searchInput) : null;
      if (input && input.value.length === 0){
        evt.preventDefault();
        // Deviation (#18 B1): the original called searchFocus($input) here,
        // a function that does not exist anywhere in this theme — it would
        // throw a ReferenceError immediately after preventDefault() already
        // ran, so the only observable effect was "submit is blocked, dead
        // handler aborts". We preserve that outcome (preventDefault, no
        // submit) and additionally focus the input instead of throwing.
        input.focus();
      }
    });
  }
    return { init:init };
})();

theme.Product = (function(){
  // Module-level once-guard for the sticky add-to-cart bar handlers. The sticky
  // bar (.stickyOpt / .stickyQty / #stquantity) is global page furniture rendered
  // OUTSIDE every product section's data-section-id container (verified: in
  // main-product.liquid #ProductSection-{id} closes before .stickyCart, so these
  // selectors never resolve inside a section). The original jQuery selectors were
  // unscoped and re-bound on every Product init, so a PDP + featured-product on one
  // page stacked a handler per element per section (a leak). Document-delegated +
  // bound once (house pattern) fixes that while preserving single-section behavior.
  var stickyHandlersBound = false;

  function Product(container){
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.settings={
      mediaQueryMediumUp: 'screen and (min-width: 768px)',
      mediaQuerySmall: 'screen and (max-width: 767px)',
      bpSmall: false,
      zoomEnabled: false
    };
    this.selectors={ imgZoom: '.przoom' + sectionId }
      
    if (!customElements.get('media-gallery')) {
        customElements.define('media-gallery', class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.setActiveMedia(this.dataset.target);
            }
            setActiveMedia(mediaId){
                var breakpoint = window.matchMedia('(min-width: 768px)'),
                    prslider,
                    sliderId = this.dataset.section,
                    opt = document.querySelector(this.dataset.section)?.getAttribute('data-slider-options');

                function getDirection(){
                    if(document.querySelector('.thumbs_nav.bottom')){
                        var direction = 'horizontal';
                    } else {
                        var direction = window.innerWidth >= 767 ? 'vertical' : 'horizontal';
                    }
                    return direction;
                }
                // Positioning runs after prslider exists (enableSwiper resolves async now),
                // or synchronously for the desktop path that scrolls instead of using Swiper.
                var goToActiveMedia = function(){
                    // querySelector(...)?.getAttribute → undefined when the element is
                    // missing, null when the attribute is missing; both are `== undefined`,
                    // so the guard below short-circuits exactly as the jQuery .attr()
                    // (undefined) version did — plain getAttribute needs no null handling.
                    var activeMedia = document.querySelector('.pr_photo:not(.swiper-slide-duplicate):not(.swiper-slide-thumb-active)[data-id="'+mediaId+'"]')?.getAttribute('data-slide');
                    if(activeMedia == undefined){ return; }
                    if(prslider !== undefined){
                        prslider.slideToLoop(activeMedia);
                    } else if(theme.productStrings.prStyle == "2" || theme.productStrings.prStyle == "3" || theme.productStrings.prStyle == "4" ){
                        var imgEl = document.querySelector('.pr_photo[data-id="'+mediaId+'"]');
                        if(window.innerWidth > 767 && imgEl){
                            var top = imgEl.getBoundingClientRect().top + window.pageYOffset;
                            window.scrollTo({ top: top - 70, behavior: 'smooth' });
                        }
                    }
                };
                var breakpointChecker = function(){
                    if(theme.productStrings.prStyle != "1" && theme.productStrings.prStyle != "5" ){
                        if (breakpoint.matches === true){
                            if( prslider !== undefined ) prslider.destroy();
                            goToActiveMedia();
                            return;
                        } else if (breakpoint.matches === false){
                            return enableSwiper();
                        }
                    } else {
                        return enableSwiper();
                    }
                };
                var enableSwiper = function(){
                    window.withSwiper(function(){
                    prslider = new Swiper (sliderId, JSON.parse(opt));
                    prslider.thumbs.swiper.changeDirection(getDirection());
                    window.addEventListener('resize', function(){
                        prslider.thumbs.swiper.changeDirection(getDirection());
                    });

                    prslider.on('slideChange', function(){
                        var videos = document.querySelectorAll('.primgSlider video'),
                        // Swiper 8's slides is an array-like of plain elements (no Dom7 .eq()).
                        slide = prslider.slides[prslider.activeIndex],
                        video = slide.querySelector('video');
                        Array.prototype.forEach.call(videos, function(v){ v.pause(); });
                        if(video){ video.play(); }
                    });
                    goToActiveMedia();
                    });
                }
                breakpointChecker();
            }
        });
    }
  
    // Product tabs
    initProductTabs();

    // Sticky bar handlers: document-delegated, bound once (see stickyHandlersBound
    // note above). sectionId is captured from the first Product to init, which on a
    // normal PDP is the product's own section (the variants{id} JSON lives inside it).
    if (!stickyHandlersBound){
      stickyHandlersBound = true;
      _bindStickyBar(sectionId);
    }

    // change variant on image sections. Element-bound per init (parity with the
    // original .bind), guarded by the same typeof-variantImages check: .pr_thumb
    // lives INSIDE this product section, so Theme Editor re-renders replace the
    // elements and this simply re-binds onto the fresh ones (no stacking).
    if (typeof variantImages !== 'undefined'){
      document.querySelectorAll('.pr_thumb').forEach(function(thumb){
        thumb.addEventListener('click', function(){
          var arrImage = this.getAttribute('data-img').split('?')[0].split('.');
          var strExtention = arrImage.pop();
          var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
          var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
          if (typeof variantImages[strNewImage] !== 'undefined'){
              productOptions.forEach(function (value, i){
               optionValue = variantImages[strNewImage]['option-'+i];
                var pvOpt = document.querySelector('.pvOpt'+i);
                if(pvOpt && pvOpt.querySelector('.swatchInput')){
                  if (optionValue !== null && Array.prototype.some.call(document.querySelectorAll('.pvOpt'+i+' .swatchInput'), function(el){ return el.value === optionValue; })){
                     pvOpt.querySelectorAll('.swatchInput[value="'+optionValue+'"]').forEach(function(el){ el.click(); });
                   }
                } else {
                  // .select__select:eq(i) → the nth .select__select (:eq isn't valid CSS).
                  var selectEl = document.querySelectorAll('.select__select')[i];
                  if (optionValue !== null && selectEl && Array.prototype.some.call(selectEl.querySelectorAll('option'), function(o){ return o.textContent === optionValue; })){
                     document.querySelectorAll('.pvOpt'+i+' select').forEach(function(sel){ sel.value = optionValue; sel.dispatchEvent(new Event('change', {bubbles:true})); });
                   }
                }
            });
          }
        });
      });
    }

    this.settings.zoomEnabled = document.querySelectorAll(this.selectors.imgZoom).length;
    this._initBreakpoints();
    this._stringOverrides();
  }

  Object.assign(Product.prototype,{
    _stringOverrides: function(){
      theme.productStrings = theme.productStrings || {}; // load-bearing: media-gallery reads prStyle.
      // The original `$.extend(theme.strings, theme.productStrings)` was a silent
      // no-op — theme.strings is defined nowhere in the theme, so jQuery built and
      // discarded a throwaway object. Guard so we only merge if it ever exists.
      if (theme.strings){ Object.assign(theme.strings, theme.productStrings); }
    },
    _initBreakpoints: function(){
      // enquire.register (vendor.js, deleted in #23) → native matchMedia. enquire fired
      // match immediately when the query already held; the initial handler calls keep that.
      var self = this;
      var small = window.matchMedia(this.settings.mediaQuerySmall);
      var onSmall = function(mq){
        if (mq.matches){
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled){
            _destroyZoom(self.selectors.imgZoom);
          }
          self.settings.bpSmall = true;
        } else {
          self.settings.bpSmall = false;
        }
      };
      small.addEventListener('change', onSmall);
      onSmall(small);
      var mediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
      var onMediumUp = function(mq){
        if (mq.matches && self.settings.zoomEnabled){
          _enableZoom(self.selectors.imgZoom);
        }
      };
      mediumUp.addEventListener('change', onMediumUp);
      onMediumUp(mediumUp);
    },
    // No-op: the jQuery original did this.$container.off(namespace), but there is no
    // jQuery container any more and settings.namespace was never set (dead code). In
    // design mode admin.js overwrites this prototype (and this onUnload) via _.assignIn
    // with its own productMedia teardown, so the editor path is unaffected.
    onUnload: function(){}
  });
  // Vanilla hover-zoom (#21, jq-eviction 14d) — replaces jquery.zoom (jacklmoore
  // Zoom 1.7.15, in vendor.js). Same behavior: append the high-res data-zoom image
  // at its natural size (overflowing the container, which is overflow:hidden in the
  // theme CSS) and pan it under the cursor via translate; fade in/out on enter/leave.
  // Enabled only >=768px (matchMedia desktop breakpoint), destroyed on the small one.
  // Listeners are grouped under an AbortController stored on the element so
  // _destroyZoom can remove them cleanly (jQuery's `zoom.destroy` custom event did
  // the same teardown).
  function _enableZoom(selector){
    document.querySelectorAll(selector).forEach(function(el){
      if (el._zoomCtl) return; // already enabled
      var ctl = new AbortController();
      el._zoomCtl = ctl;
      if (getComputedStyle(el).position === 'static'){ el.style.position = 'relative'; }
      var zoomImg = null;
      el.addEventListener('mouseenter', function(){
        var url = el.dataset.zoom;
        if (!url || zoomImg) return;
        zoomImg = document.createElement('img');
        zoomImg.className = 'zoomImg';
        zoomImg.style.cssText = 'position:absolute;top:0;left:0;opacity:0;border:none;max-width:none;max-height:none;pointer-events:none;transition:opacity .2s;';
        zoomImg.onload = function(){ if (zoomImg) zoomImg.style.opacity = '1'; };
        zoomImg.src = url;
        el.appendChild(zoomImg);
      }, { signal: ctl.signal });
      el.addEventListener('mousemove', function(e){
        if (!zoomImg) return;
        var rect = el.getBoundingClientRect();
        var dx = zoomImg.offsetWidth - rect.width;
        var dy = zoomImg.offsetHeight - rect.height;
        var px = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        var py = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
        zoomImg.style.transform = 'translate(' + (-dx * px) + 'px,' + (-dy * py) + 'px)';
      }, { signal: ctl.signal });
      el.addEventListener('mouseleave', function(){
        if (!zoomImg) return;
        var z = zoomImg; zoomImg = null;
        z.style.opacity = '0';
        setTimeout(function(){ if (z.parentNode) z.parentNode.removeChild(z); }, 200);
      }, { signal: ctl.signal });
    });
  }
  function _destroyZoom(selector){
    document.querySelectorAll(selector).forEach(function(el){
      if (el._zoomCtl){ el._zoomCtl.abort(); el._zoomCtl = null; }
      var z = el.querySelector('.zoomImg'); if (z) z.parentNode.removeChild(z);
    });
  }

  // Sticky add-to-cart bar handlers (global page furniture, see stickyHandlersBound).
  function _bindStickyBar(sectionId){
    // .stickyOpt .selectedOpt → toggle the variant dropdown ("fast" = 200ms).
    document.addEventListener('click', function(e){
      if (!e.target.closest('.stickyOpt .selectedOpt')) return;
      var ul = document.querySelector('.stickyOpt ul');
      if (!ul) return;
      if (getComputedStyle(ul).display === 'none'){ theme.utils.slideDown(ul, 200); }
      else { theme.utils.slideUp(ul, 200); }
    });

    // .stickyOpt .vrOpt → pick a variant from the sticky bar, mirror it into the real
    // (in-section) option pickers. Native change dispatch (rule 3) is heard by BOTH
    // jQuery listeners AND cart.js's native variant-selects listener.
    document.addEventListener('click', function(e){
      var vr = e.target.closest('.stickyOpt .vrOpt');
      if (!vr) return;
      var number = theme.utils.parseData(vr, 'no');
      var selectedOpt = document.querySelector('.stickyOpt .selectedOpt');
      if (selectedOpt){ selectedOpt.innerHTML = vr.innerHTML; }
      theme.utils.slideUp(document.querySelector('.stickyOpt ul'), 200);
      vr.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
      var stOpt = vr.productvariants[number],
          o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
      var stImg = document.querySelector('.stickCtImg');
      if (stImg){ stImg.setAttribute('src', stOpt.featured_image.src+'&width=100'); }
      if (document.querySelector('select.single-option-selector')){
        // :eq(n) → the nth .single-option-selector, with null-guards.
        var sels = document.querySelectorAll('.single-option-selector');
        if(o2 != null && sels[1]){ sels[1].value = o2; }
        if(o3 != null && sels[2]){ sels[2].value = o3; }
        if(o1 != null && sels[0]){ sels[0].value = o1; sels[0].dispatchEvent(new Event('change', {bubbles:true})); }
      } else {
        // Faithful port of the original's (quirky) escaped-quote selector string:
        // o.replace(/'/g, "\\'") interpolated into [value='...']. querySelectorAll +
        // forEach preserves jQuery's set semantics (all matches; no-op when empty).
        if(o2 != null){ var stOpt2 = o2.replace(/'/g, "\\'"); document.querySelectorAll(".swatchInput[value='"+stOpt2+"']").forEach(function(el){ el.checked = true; }); }
        if(o3 != null){ var stOpt3 = o3.replace(/'/g, "\\'"); document.querySelectorAll(".swatchInput[value='"+stOpt3+"']").forEach(function(el){ el.checked = true; }); }
        if(o1 != null){ var stOpt1 = o1.replace(/'/g, "\\'"); document.querySelectorAll(".swatchInput[value='"+stOpt1+"']").forEach(function(el){ el.click(); }); }
      }
    });

    // .stickyQty .qtyBtn → +/- the (in-section) .mianQty input; native change dispatch
    // feeds the .mianQty listener below and cart.js.
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.stickyQty .qtyBtn');
      if (!btn) return;
      var qtyField = document.querySelector('.mianQty');
      if (!qtyField) return;
      var oldValue = qtyField.value, newVal = 1;
      if (btn.matches('.plus')){
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1){
        newVal = parseInt(oldValue) - 1;
      }
      qtyField.value = newVal;
      qtyField.dispatchEvent(new Event('change', {bubbles:true}));
    });

    // .mianQty change → mirror into the sticky #stquantity display. Delegated (not
    // element-bound) so the qtyBtn's bubbling change dispatch above reaches it and it
    // survives editor re-renders; bound once alongside the rest of the sticky bar.
    document.addEventListener('change', function(e){
      var mq = e.target.closest('.mianQty');
      if (!mq) return;
      var stq = document.getElementById('stquantity');
      if (stq){ stq.value = mq.value; }
    });
  }
  return Product;
})();

// Product tabs (desktop tab strip + mobile accordion). Document-delegated so
// they keep working across Theme Editor section re-renders; no-op when
// #PrSecTabs / .prtabAcr aren't present on the page.
function initProductTabs(){
  document.querySelectorAll('#PrSecTabs .product-tabs li:first-child, #PrSecTabs .prtabAcr:first-child').forEach(function(el){
    el.classList.add('active');
  });
  var firstTbCnt = document.querySelector('#PrSecTabs .tbs_wrp .tb_cnt');
  if (firstTbCnt){ firstTbCnt.style.display = 'block'; }
}

document.addEventListener('click', function(e){
  var tablink = e.target.closest('#PrSecTabs .product-tabs .tablink');
  if (tablink){
    e.preventDefault();
    var li = tablink.parentElement;
    li.classList.add('active');
    Array.prototype.forEach.call(li.parentElement.children, function(sibling){
      if (sibling !== li){ sibling.classList.remove('active'); }
    });
    var tab = tablink.getAttribute('href');
    var tabTarget = theme.utils.idOrQuery(tab);
    document.querySelectorAll('.tb_cnt').forEach(function(el){
      if (el !== tabTarget){ el.style.display = 'none'; }
    });
    theme.utils.fadeIn(tabTarget);
    return;
  }

  var prtabAcr = e.target.closest('.prtabAcr');
  if (prtabAcr){
    prtabAcr.classList.toggle('active');
    theme.utils.slideToggle(prtabAcr.nextElementSibling);
  }
});

theme.slideshows={};
theme.SlideshowSection = (function(){
  function SlideshowSection(container){
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    var slideshow = '#ss' + sectionId;
    var slideshowEl = document.querySelector(slideshow);

    // parseData mirrors jQuery .data(): data-loop / data-autoplay "true"/"false"
    // → booleans, data-autoplay's JSON object → object, data-effect "fade"/"slide"
    // → raw string (JSON.parse throws → falls back to the string). Exact parity.
    var loop = theme.utils.parseData(slideshowEl, 'loop');
    var fade = theme.utils.parseData(slideshowEl, 'effect');
    var autoplay = theme.utils.parseData(slideshowEl, 'autoplay');
    // withSwiper stays exactly here: on eager templates (index) window.Swiper is
    // already present so this runs synchronously — that timing is load-bearing (#17).
    window.withSwiper(function(){
    var slswiper = new Swiper(slideshow, {
      preloadImages:false,
      lazy: true,
      loop: loop,
      slidesPerView:1,
      effect: fade,
      autoplay: autoplay,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    theme.slideshows = slswiper;
    });

    var iframes = slideshowEl ? slideshowEl.querySelectorAll('.embed-player') : [];
    resizePlayer(iframes, 16/9, slideshowEl);
    // The constructor runs per slideshow instance, so (as in the original) each
    // instance adds its own window resize listener — they stack, matching parity.
    // Stored on `this` so a future onUnload could removeEventListener it.
    this.resizeHandler = function(){
      resizePlayer(iframes, 16/9, slideshowEl);
    };
    window.addEventListener('resize', this.resizeHandler);
  }

    // Resize player
    function resizePlayer(iframes, ratio, slideshow){
      if (!iframes[0]) return;
      var width = slideshow.clientWidth,   // jQuery .width() → clientWidth
          playerWidth,
          height = slideshow.clientHeight, // jQuery .height() → clientHeight
          playerHeight;
      ratio = ratio || 16/9;

      iframes.forEach(function(current){
        // jQuery added 'px' automatically for .width()/.height()/.css(left|top) — keep the units.
        if (width / ratio < height){
          playerWidth = Math.ceil(height * ratio);
          current.style.width = playerWidth + 'px';
          current.style.height = height + 'px';
          current.style.left = ((width - playerWidth) / 2) + 'px';
          current.style.top = '0px';
        } else {
          playerHeight = Math.ceil(width / ratio);
          current.style.width = width + 'px';
          current.style.height = playerHeight + 'px';
          current.style.left = '0px';
          current.style.top = ((height - playerHeight) / 2) + 'px';
        }
      });
    }

  return SlideshowSection;
})();

// CATEGORY SLIDER
theme.collectionView = (function(){
  var delegatesBound = false;

  function collectionView(container){
    this.container = container;

    // The constructor runs once per collection-template section (home's
    // products-rows + main-collection can coexist) and again on Theme Editor
    // re-init. All listeners below are document/window-delegated → bind once.
    if (delegatesBound) return;
    delegatesBound = true;

    document.addEventListener('click', function(e){
      var flTtl = e.target.closest('.flTop .flTtl');
      if (!flTtl) return;
      var thisBlk = flTtl.closest('.filterBx');
      document.querySelectorAll('.filterBx').forEach(function(el){
        if (el !== thisBlk) el.removeAttribute('open');
      });
    });

    document.addEventListener('change', function(e){
      var sortBySt = e.target.closest('#SortBySt');
      if (!sortBySt) return;
      var value = sortBySt.value;
      if (!document.querySelector('#CollectionFiltersForm')){
        var href = new URL(window.location.href);
        href.searchParams.set('sort_by', value);
        window.location = href.toString();
      } else {
        var sortBy = document.querySelector('#SortBy');
        if (sortBy){
          sortBy.value = value;
          sortBy.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    document.addEventListener('click', function(e){
      var changeView = e.target.closest('.change-view');
      if (!changeView) return;
      var view = theme.utils.parseData(changeView, 'view');
      var href = new URL(window.location.href);
      href.searchParams.set('pgview', view);
      href.searchParams.set('type', view);
      window.location = href.toString();
    });

    document.addEventListener('change', function(e){
      var target = e.target.closest('.dyfl, .prRange, #SortBy');
      if (!target) return;
      var url = '//' + window.location.hostname + window.location.pathname;
      var form = document.querySelector('#CollectionFiltersForm');
      var formdata = form ? new URLSearchParams(new FormData(form)).toString() : '';
      ajaxfilter(url + '?' + formdata);
    });

    document.addEventListener('click', function(e){
      var removefl = e.target.closest('.removefl');
      if (!removefl) return;
      e.preventDefault();
      var url = '//' + window.location.hostname + removefl.getAttribute('href');
      ajaxfilter(url);
    });

    ajaxfilter = function(url){
      document.body.classList.add('loading', 'hideOverly');
      fetch(url).then(function(response){
        return response.text();
      }).then(function(text){
        var parsed = new DOMParser().parseFromString(text, 'text/html');

        function copyHTML(selector){
          var live = document.querySelector(selector);
          if (!live) return;
          var parsedEl = parsed.querySelector(selector);
          live.innerHTML = parsedEl ? parsedEl.innerHTML : '';
        }

        copyHTML('#collectionPr');
        copyHTML('#CollectionFiltersForm');
        copyHTML('.active-facets');
        copyHTML('.collection-product-count');

        if (window.innerWidth < 1025){
          document.querySelectorAll('.filterBx').forEach(function(el){ el.setAttribute('open', ''); });
        }

        var paginationLive = document.querySelector('.pagination');
        var paginationParsed = parsed.querySelector('.pagination');
        if (paginationLive){
          paginationLive.innerHTML = paginationParsed ? paginationParsed.innerHTML : '';
          paginationLive.style.display = (paginationParsed && paginationParsed.innerHTML) ? '' : 'none';
        }

        var infinitpaginOuterLive = document.querySelector('.infinitpaginOuter');
        var infinitpaginOuterParsed = parsed.querySelector('.infinitpaginOuter');
        if (infinitpaginOuterLive){
          infinitpaginOuterLive.innerHTML = infinitpaginOuterParsed ? infinitpaginOuterParsed.innerHTML : '';
        }
        if (!infinitpaginOuterParsed || !infinitpaginOuterParsed.innerHTML){
          var infinitpagin = document.querySelector('.infinitpagin');
          if (infinitpagin) infinitpagin.remove();
        }

        if (document.querySelector('.prRange') && typeof priceSlider === 'function'){ priceSlider(); }
        if (document.querySelector('.spr-badge')){
          SPR.registerCallbacks(); SPR.initRatingHandler(); SPR.initDomEls(); SPR.loadProducts(); SPR.loadBadges();
        }
        theme.countdown();
        history.pushState({ page: url }, url, url);
      }).finally(function(){
        document.body.classList.remove('loading', 'hideOverly');
      });
    };

    infiniteScroll = function(){
      var handler = function(){
        var moreLink = document.querySelector('.infinitpagin a');
        var moreURL = moreLink ? moreLink.getAttribute('href') : null;
        if (document.querySelector('.infinitpagin a.infinite')){
          var infinitpaginEl = document.querySelector('.infinitpagin');
          var bottom = infinitpaginEl.getBoundingClientRect().top + window.pageYOffset;
          var docTop = window.pageYOffset + window.innerHeight - 50;
          if (docTop > bottom){
            window.removeEventListener('scroll', handler);
            window.removeEventListener('load', handler);
            window.removeEventListener('delayed-resize', handler);
            loadMore(moreURL);
          }
        }
      };
      window.addEventListener('scroll', handler);
      window.addEventListener('load', handler);
      window.addEventListener('delayed-resize', handler);
    };

    loadMoreBtn = function(){
      document.addEventListener('click', function(e){
        var loadMoreLink = e.target.closest('a.loadMore');
        if (!loadMoreLink) return;
        e.preventDefault();
        var moreURL = loadMoreLink.getAttribute('href');
        loadMore(moreURL);
      });
    };

    loadMore = function(moreURL){
      if (moreURL && moreURL.length){
        var infinitpaginOuter = document.querySelector('.infinitpaginOuter');
        if (infinitpaginOuter && theme.utils.parseData(infinitpaginOuter, 'type') === 'button'){
          document.body.classList.add('loading', 'hideOverly');
        } else {
          document.querySelectorAll('.infinitpagin a').forEach(function(el){ el.style.removeProperty('display'); });
        }
        fetch(moreURL).then(function(response){
          return response.text();
        }).then(function(text){
          var parsed = new DOMParser().parseFromString(text, 'text/html');

          var collectionPr = document.querySelector('#collectionPr');
          if (collectionPr){
            var parsedCollectionPr = parsed.querySelector('#collectionPr');
            if (parsedCollectionPr){
              collectionPr.insertAdjacentHTML('beforeend', parsedCollectionPr.innerHTML);
            }
          }

          var infinitpaginLive = document.querySelector('.infinitpagin');
          var infinitpaginParsed = parsed.querySelector('.infinitpagin');
          if (infinitpaginParsed && infinitpaginParsed.innerHTML){
            if (infinitpaginLive) infinitpaginLive.innerHTML = infinitpaginParsed.innerHTML;
          } else {
            if (infinitpaginLive) infinitpaginLive.remove();
          }

          shopreviews();
          if (!document.querySelector('.infinitpagin a.loadMore')){
            infiniteScroll();
          }
          theme.countdown();
        }).finally(function(){
          document.body.classList.remove('loading', 'hideOverly');
        });
      }
    };

    infiniteScroll(); loadMoreBtn();
  }
  return collectionView;
})();

// instagramSection removed (#18 B1): dead code — no section renders data-section-type="instagram".

theme.quotesl={};
theme.Quotes = (function(){
  function Quotes(container){
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    var quotesEl = document.getElementById('Quotes-' + sectionId);

    var fade = theme.utils.parseData(quotesEl, 'effect');
    var autoplay = theme.utils.parseData(quotesEl, 'autoplay');
    var self = this;
    window.withSwiper(function(){
      var swiper = new Swiper('#Quotes-' + sectionId, {
        loop: true,
        slidesPerView: 'auto',
        effect: fade,
        autoplay: autoplay,
        pagination: {
          el: ".swpg"+sectionId,
          clickable: true,
        },
        navigation: {
          nextEl: ".swn"+sectionId,
          prevEl: ".swp"+sectionId,
        },
      });
      self.quotesl = swiper;
      swiper.on('slideChange', function(data){
        quotesEl.querySelectorAll('.swiper-slide-duplicate .bgImg.lazyloading').forEach(function(el){
          el.classList.add('lazyload');
        });
      });
    });
  }
  return Quotes;
})();

theme.slcarousel={};
theme.carousel = (function(){
  // Per-section-id guard: the constructor re-runs on Theme Editor re-render, but
  // the tab-click listener is document-delegated, so bind it once per section id
  // (following the B0/B1 once-guard house pattern, scoped per id via this Set).
  var boundSections = new Set();

  function carousel(container){
    this.container = container;
    var sectionId = container.getAttribute('data-section-id'),
        tabs = '#' + sectionId + ' .tablink',
        tabcontent = '#' + sectionId + ' .tb_cnt';

    function loadSlider(tab){
        // Faithful port of `$(tab).attr('data-swiper') ? JSON.parse(...) : {}`.
        var tabEl = tab ? document.querySelector(tab) : null;
        var raw = tabEl ? tabEl.getAttribute('data-swiper') : null;
        var optionsData = raw ? JSON.parse(raw) : {};
        window.withSwiper(function(){
            new Swiper(tab+' .tabswiper', optionsData);
        });
    }
    if(document.querySelector('#'+sectionId+'.cltabWrap')){
      var firstTabEl = document.querySelector('.cl_tbs li:first-child a');
      var fristTab = firstTabEl ? firstTabEl.getAttribute('href') : undefined;
      loadSlider(fristTab);
    }
    if(!boundSections.has(sectionId)){
      boundSections.add(sectionId);
      document.addEventListener('click', function(e){
        var link = e.target.closest(tabs);
        if(!link) return;
        e.preventDefault();
        var parent = link.parentElement;
        parent.classList.add("active");
        Array.prototype.forEach.call(parent.parentElement.children, function(sib){
          if(sib !== parent) sib.classList.remove("active");
        });
        var tab = link.getAttribute("href");
        // $(tabcontent).not(tab).hide(): all .tb_cnt in this section except the target.
        var tabEl = tab ? document.querySelector(tab) : null;
        document.querySelectorAll(tabcontent).forEach(function(el){
          if(el !== tabEl) el.style.display = 'none';
        });
        if(tabEl) tabEl.style.display = '';
        setTimeout(function() {
            loadSlider(tab);
            window.dispatchEvent(new Event('resize'));
        }, 5);
      });
    }
    var swpEl = document.querySelector('#swp'+sectionId);
    if(swpEl){
      var opt = swpEl.getAttribute("data-slider-options") || '{}';
      window.withSwiper(function(){
      swslider = new Swiper ('#swp'+sectionId, JSON.parse(opt));
      theme.slcarousel = swslider
      });
    }
  }
  return carousel;
})();

theme.masonary = (function(){
  function masonary(container){
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    var gridEl = container.querySelector('.grid-masonary');

    if (!gridEl || typeof Masonry === 'undefined'){ return; }

    this.masonary = new Masonry(gridEl, {
      columnWidth: '.grid-sizer-' + sectionId,
      itemSelector: '.msitem',
      percentPosition: true
    });

    var self = this;
    setTimeout(function(){
      if (self.masonary){ self.masonary.layout(); }
    }, 1000);
  }
  return masonary;
})();

theme.ajaxCart = function(){
    // .modalOverly click (rule 7): document-delegated, fadeOut 200ms + classList.
    // Independent of B1 Search's own delegated .modalOverly handler — both fire.
    document.addEventListener('click', function(e){
        if (!e.target.closest('.modalOverly')) return;
        document.querySelectorAll('.modal').forEach(function(el){ theme.utils.fadeOut(el, 200); });
        document.body.classList.remove('loading', 'showOverly');
    });

    // Quick view / quick shop: fetch the section HTML, open it in the vanilla
    // <dialog> modal (theme.modal, modals.js) — #20 replaced Magnific here.
    document.addEventListener('click', function(e){
        var trigger = e.target.closest('.quick-view,.quickShop');
        if (!trigger) return;
        e.preventDefault();
        document.body.classList.add('loading'); // beforeSend
        fetch(trigger.getAttribute('href')).then(function(r){ return r.text(); }).then(function(data){
            theme.modal.openHtml(data, {
              effect: 'mfp-zoom-in',
              removalDelay: 500,
              beforeOpen: function(){
                document.querySelectorAll('.sticky_hdr').forEach(function(el){ el.classList.add('popup'); });
              },
              onClose: function(){
                document.querySelectorAll('.sticky_hdr').forEach(function(el){ el.classList.remove('popup'); });
                var pp = document.querySelector('#quickv_pp'); if (pp){ pp.innerHTML = ''; }
              }
            });
        }).finally(function(){
            document.body.classList.remove('loading'); // complete
        });
    });

    document.addEventListener('click', function(e){
        if (!e.target.closest('.quickShop')) return;
        document.querySelectorAll('.ctdrawer').forEach(function(el){ el.classList.add('poptop'); });
    });

    // .add-to-cart (rule 4): the jQuery next().find('.cartBtn').trigger('click')
    // targeted a native submit button, so trigger('click') invoked its native
    // click(); ported to nextElementSibling.querySelector('.cartBtn').click() +
    // null-guards (parity, no behavior change).
    document.addEventListener('click', function(e){
        var addToCart = e.target.closest('.add-to-cart');
        if (!addToCart) return;
        e.preventDefault();
        document.body.classList.add('loading');
        var sib = addToCart.nextElementSibling;
        var cartBtn = sib ? sib.querySelector('.cartBtn') : null;
        if (cartBtn){ cartBtn.click(); }
    });

    document.addEventListener('click', function(e){
        var trigger = e.target.closest('.addto-wishlist');
        if (!trigger) return;
        e.preventDefault();
        var id = trigger.getAttribute('rel');
        var str;
        if (localStorage.getItem('wishlist') == null){
          str = id;
        } else {
          if(localStorage.getItem('wishlist').indexOf(id) == -1) {
            str = localStorage.wishlist + '+' + id;
            str = str.replace('++', '+');
          }
        }
        localStorage.setItem('wishlist', str);
        var icon = trigger.querySelector('.at-icon');
        if (icon){ icon.classList.add('at-flip'); }
        setTimeout(function(){
          document.querySelectorAll('.wishlist[rel="'+id+'"]').forEach(function(el){
            el.classList.remove('addto-wishlist');
            el.querySelectorAll('span').forEach(function(span){ span.textContent = theme.wlAvailable; });
          });
          document.querySelectorAll('.wishlist[rel="'+id+'"] .at-icon').forEach(function(el){
            el.classList.remove('at-flip');
            el.classList.add('added');
          });
        }, 1500);
    });
    if(localStorage.getItem('wishlist') != null && localStorage.getItem('wishlist') != '+'){
       var wl = String(localStorage.getItem('wishlist')).split("+");
       for (var i=0; i<wl.length; i++) {
         if (wl[i] != ''){
           document.querySelectorAll('.wishlist[rel="'+wl[i]+'"]').forEach(function(el){
             el.classList.remove('addto-wishlist');
             el.querySelectorAll('span').forEach(function(span){ span.textContent = theme.wlAvailable; });
           });
           document.querySelectorAll('.wishlist[rel="'+wl[i]+'"] .at-icon').forEach(function(el){ el.classList.add('added'); });
           document.querySelectorAll('.favCount').forEach(function(el){ el.textContent = i; el.classList.remove('hide'); });
         }
       }
    }

    var atcm = 'compareproducts';
    document.addEventListener('click', function(e){
        var trigger = e.target.closest('.addto-compare');
        if (!trigger) return;
        e.preventDefault();
        var id = String(trigger.getAttribute('rel')),
            compareItems = JSON.parse(localStorage.getItem(atcm) || '[]');

         if(!compareItems.includes(id)){
             compareItems.unshift(id);
             localStorage.setItem(atcm, JSON.stringify(compareItems));
         } else {
             var index = compareItems.indexOf(id);
             compareItems.splice(index, 1);
             localStorage.setItem(atcm, JSON.stringify(compareItems));
         }

        var icon = trigger.querySelector('.at-icon');
        if (icon){ icon.classList.add('at-flip'); }
        setTimeout(function(){
          document.querySelectorAll('.compare[rel="'+id+'"]').forEach(function(el){
            el.classList.remove('addto-compare');
            el.querySelectorAll('span').forEach(function(span){ span.textContent = theme.browseCmp; });
          });
          document.querySelectorAll('.compare[rel="'+id+'"] .at-icon').forEach(function(el){
            el.classList.remove('at-flip');
            el.classList.add('added');
          });
        }, 1500);
    });
    if(localStorage.getItem(atcm) != null && localStorage.getItem(atcm) != '+'){
       var cmp = JSON.parse(localStorage.getItem(atcm));
       if(cmp == null) return;
       for (var j=0; j<cmp.length; j++) {
         if (cmp[j] != ''){
           document.querySelectorAll('.compare[rel="'+cmp[j]+'"]').forEach(function(el){
             el.classList.remove('addto-compare');
             el.querySelectorAll('span').forEach(function(span){ span.textContent = theme.browseCmp; });
           });
           document.querySelectorAll('.compare[rel="'+cmp[j]+'"] .at-icon').forEach(function(el){ el.classList.add('added'); });
         }
       }
    }
};
theme.utils.onReady(theme.ajaxCart);

theme.utils.onReady(function(){
  var sections = new theme.Sections();
  sections.register('header', theme.HeaderSection);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.collectionView);
  sections.register('slideshow', theme.SlideshowSection);
  sections.register('carousel', theme.carousel );
  sections.register('quotes', theme.Quotes);
  sections.register('masonary', theme.masonary);
});

var resizeTimer;
window.addEventListener('resize', function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function(){
    window.dispatchEvent(new CustomEvent('delayed-resize'));
  }, 250);
});

theme.countdown = function(){
  document.querySelectorAll('.saleTime, .atCounter').forEach(function(el){
    var date = el.dataset.date;
    var countDownDate = new Date(date).getTime();
    var x = setInterval(function(){
      var now = new Date().getTime(),
          distance = countDownDate - now,
          days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(days > 99){
          days = ("00" + days).substr(-3);
      } else {
          days = ("00" + days).substr(-2);
      }
      hours = ("00" + hours).substr(-2);
      minutes = ("00" + minutes).substr(-2);
      seconds = ("00" + seconds).substr(-2);

      var daysEl = el.querySelector('.days');
      var hoursEl = el.querySelector('.hours');
      var minutesEl = el.querySelector('.minutes');
      var secondsEl = el.querySelector('.seconds');
      if (daysEl){ daysEl.innerHTML = days; }
      if (hoursEl){ hoursEl.innerHTML = hours; }
      if (minutesEl){ minutesEl.innerHTML = minutes; }
      if (secondsEl){ secondsEl.innerHTML = seconds; }

      if (distance < 0){
        clearInterval(x);
        el.style.display = 'none';
        var timerl = el.closest('.timerl');
        if (timerl){ timerl.style.display = 'none'; }
      }
    }, 1000);
  });
}

theme.init = function() {
  slate.rte.wrapTable();
  slate.rte.iframeReset();
  theme.countdown();

  // Common a11y fixes
  slate.a11y.pageLinkFocus(window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null);

  document.addEventListener('click', function(e){
    var link = e.target.closest('.in-page-link');
    if (link){
      slate.a11y.pageLinkFocus(document.querySelector(link.hash));
    }
  });

  document.addEventListener('click', function(e){
    if (e.target.closest('a[href="#"]')){
      e.preventDefault();
    }
  });
};
theme.utils.onReady(theme.init);

// STICKY HEADER / STICKY CART / SITE SCROLLER
// (native rAF-throttled scroll listener — the old jQuery version started a
// fresh setInterval on every single scroll event, leaking an ever-growing
// pile of intervals; this uses one persistent handler instead.)
theme.utils.onReady(function(){
  var hdrWrap = document.querySelector('.hdr_wrap');
  var stickyCart = document.querySelector('.stickyCart');
  var scrollTopBtn = document.getElementById('scroll_top');

  var lastScroll = 0;
  var hdpos = hdrWrap ? (hdrWrap.getBoundingClientRect().top + window.pageYOffset) : 0;
  var headht = hdrWrap ? hdrWrap.clientHeight : 0;

  function sticky_header(){
    var scroll = window.pageYOffset || document.documentElement.scrollTop;
    if (theme.stickyHeader == 'top'){
      if (hdrWrap){
        if (scroll > headht && scroll > lastScroll){
          hdrWrap.classList.remove('sticky_hdr', 'fadeInDown');
        } else if (scroll <= headht){
          hdrWrap.classList.remove('sticky_hdr', 'fadeInDown');
        } else if (scroll < lastScroll){
          hdrWrap.classList.add('sticky_hdr', 'animated', 'fadeInDown');
        }
      }
      lastScroll = scroll;
    } else if (theme.stickyHeader == 'always'){
      if (hdrWrap){
        if (scroll > hdpos){
          hdrWrap.classList.add('sticky_hdr');
        } else {
          hdrWrap.classList.remove('sticky_hdr');
        }
      }
    }
  }

  var ticking = false;
  function onScrollTick(){
    ticking = false;
    sticky_header();

    var scroll = window.pageYOffset || document.documentElement.scrollTop;

    /// sticky cart
    if (scroll > 600 && stickyCart){
      if (document.body.classList.contains('template-product')){
        document.body.style.paddingBottom = '70px';
      }
      theme.utils.slideDown(stickyCart);
    } else {
      if (document.body.classList.contains('template-product')){
        document.body.style.paddingBottom = '0';
      }
      if (stickyCart){ theme.utils.slideUp(stickyCart); }
    }

    // SITE SCROLLER
    if (scrollTopBtn){
      if (scroll > 200){
        scrollTopBtn.classList.add('active');
      } else {
        scrollTopBtn.classList.remove('active');
      }
    }
  }

  window.addEventListener('scroll', function(){
    if (!ticking){
      window.requestAnimationFrame(onScrollTick);
      ticking = true;
    }
  }, { passive: true });

  if (scrollTopBtn){
    scrollTopBtn.addEventListener('click', function(e){
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    });
  }
});

// Footer links accordion for mobile — delegated on document so it survives
// Theme Editor section re-renders.
document.addEventListener('click', function(e){
  var h4 = e.target.closest('.f_links .h4');
  if (!h4) return;
  if (window.innerWidth < 769){
    h4.classList.toggle('active');
    theme.utils.slideToggle(h4.nextElementSibling);
  }
});

// LOOKBOOK SHOP
document.addEventListener('click', function(e){
  var btnShop = e.target.closest('.btn-shop');
  if (!btnShop) return;
  document.querySelectorAll('.btn-shop').forEach(function(el){
    if (el !== btnShop) el.classList.remove('active');
  });
  var btnShopNext = btnShop.nextElementSibling;
  document.querySelectorAll('.products .lb_shop, .grid-lookbook').forEach(function(el){
    if (el !== btnShopNext) el.classList.remove('active');
  });
  var lookbookParent = btnShop.closest('.grid-lookbook');
  if (lookbookParent) lookbookParent.classList.add('active');
  btnShop.classList.toggle('active');
  if (btnShopNext) btnShopNext.classList.toggle('active');
});

// SHOW HIDE PRODUCT Filters
document.addEventListener('click', function(e){
  if (!e.target.closest('.btn-filter,.mbtFilter')) return;
  document.documentElement.classList.toggle('showOverly');
  document.documentElement.classList.toggle('stopScroll');
  document.querySelectorAll('.sb_filter').forEach(function(el){
    el.classList.toggle('active');
    el.classList.remove('flTop');
  });
  if (!document.querySelector('.filterBx[open]')){
    document.querySelectorAll('.filterBx').forEach(function(el){ el.setAttribute('open', ''); });
  }
});
document.addEventListener('click', function(e){
  if (!e.target.closest('.closeFilter')) return;
  document.documentElement.classList.remove('showOverly');
  document.documentElement.classList.remove('stopScroll');
  document.querySelectorAll('.sb_filter').forEach(function(el){ el.classList.remove('active'); });
});

// Product-card variant swatch → image swap
document.addEventListener('click', function(e){
  var li = e.target.closest('.grswatches li');
  if (!li || li.classList.contains('noImg')) return;
  // Items without a rel (e.g. the "+N" .numb counter) have no image to swap:
  // jQuery's attr('src', undefined) was a silent no-op, setAttribute would
  // write a broken "null" src — skip before touching anything.
  var newImage = li.getAttribute('rel');
  if (!newImage) return;
  e.preventDefault();
  e.stopPropagation();
  var gridBx = li.closest('.grid_bx');
  var gridWrapper = gridBx ? gridBx.querySelector('.grid_img_wr') : null;

  if (gridWrapper){
    gridWrapper.classList.add('showLoading');
    var variantImg = gridWrapper.querySelector('.variantImg');
    if (variantImg){
      variantImg.setAttribute('src', newImage);
      variantImg.removeAttribute('srcset');
    }
  }

  var image = new Image();
  image.src = newImage;
  image.onload = function(){
    if (gridWrapper){
      gridWrapper.classList.remove('showLoading');
      gridWrapper.classList.add('showVariantImg');
    }
    if (li.parentElement){
      Array.prototype.forEach.call(li.parentElement.children, function(sibling){
        if (sibling !== li) sibling.classList.remove('active');
      });
    }
    li.classList.add('active');
  };
});
document.addEventListener('click', function(e){
  var li = e.target.closest('.grswatches li.numb');
  if (!li) return;
  var grswatches = li.closest('.grswatches');
  if (grswatches){
    grswatches.querySelectorAll('.hide').forEach(function(el){ el.classList.remove('hide'); });
  }
  li.classList.add('hide');
});

// Cart drawer open (rule 8): document-delegated vanilla — body overflow-hidden
// class + .ctdrawer active.
document.addEventListener('click', function(e){
  var cartOpen = e.target.closest('.cartOpen');
  if (!cartOpen) return;
  e.preventDefault();
  document.body.classList.add('overflow-hidden');
  document.querySelectorAll('.ctdrawer').forEach(function(el){ el.classList.add('active'); });
});

// #20: the global `.mfp-link` Magnific delegate lived here — replaced by the
// document-delegated `.mfp` binding in modals.js (theme.modal). Removed with it,
// this was the last jQuery `$(document).ready` block in theme.js.

function htmlDecode(input){
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
}
function freeShippMsg(){
    if (document.querySelector('.freeShipMsg')){
        fetch(window.routes.url+'/?section_id=cart-drawer').then((response) => response.text()).then((responseText) => {
            var html = new DOMParser().parseFromString(responseText, 'text/html')
            var destination = document.querySelector('.freeShipMsg');
            var source = html.querySelector('.ctfreeship');
            if (source && destination) destination.innerHTML = source.innerHTML;
        });
    }
}
freeShippMsg();
function shopreviews(){
    if (document.querySelector('.spr-badge')){
        SPR.registerCallbacks();
        SPR.initRatingHandler();
        SPR.initDomEls();
        SPR.loadProducts();
        SPR.loadBadges();
    }
}